<template>
<div class="date-pagination-wrapper">

  <div class="icon-box">
    <img :src="calendarIcon"/>
  </div>

  <blank :value="6"/>

  <date-picker v-model="startValue" :onSelected="onStartSelected"/>

  <blank :value="9"/>

  <div class="hyphen"></div>

  <blank :value="9"/>

  <div class="icon-box">
    <img :src="calendarIcon"/>
  </div>

  <blank :value="6"/>

  <date-picker v-model="endValue" :disabledRange="disabledRange" :onSelected="onEndSelected"/>

  <blank :value="9"/>

</div>
</template>

<script>
import _ from 'lodash';
import CalendarIcon from '@/assets/icons/ic-calendar.svg';
import Blank from '@/spa/components/LayoutBlank';
import DatePicker from '../../modules/date-paginator/Datepicker';

export default {
  name: 'DatePaginator',
  components: {
    DatePicker,
    Blank,
  },
  props: {
    start: Date,
    end: Date,
    onStartSelected: {
      type: Function,
      default: () => {},
    },
    onEndSelected: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    startValue(value) {
      this.setDisableRange(value);
      this.$emit('start', value);
    },

    endValue(value) {
      this.$emit('end', value);
    },
  },
  methods: {
    getYesterday(value) {
      const currentDate = _.cloneDeep(value);
      return new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    },

    setDisableRange(value) {
      this.disabledRange = [{
        from: new Date(0, 1, 1),
        to: this.getYesterday(value),
      }];
    },
  },
  mounted() {
    this.setDisableRange(this.startValue);
  },
  data() {
    return {
      startValue: this.start,
      endValue: this.end,
      calendarIcon: CalendarIcon,
      disabledRange: [],
    };
  },
};
</script>

<style lang="scss" scoped>
.date-pagination-wrapper {
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;

  .hyphen {
    width: 16px;
    height: 1px;

    background-color: rgba(0, 0, 0, 0.6);
  }

  .icon-box {
    width: 24px;
    height: 24px;

    background-color: rgb(255, 255, 255);
    border-radius: 4px;
  }

}

@media screen and (max-width: 1024px) {
  .date-pagination-wrapper {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutDatePaginator.vue